import { render, staticRenderFns } from "./V_Sklad.vue?vue&type=template&id=57301c3c&"
import script from "./V_Sklad.vue?vue&type=script&lang=js&"
export * from "./V_Sklad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports